import { EloPriceDisplay } from '@elo-ui/components/elo-price-display'
import { buildPricingPlanSupportiveText } from 'shared/components/pricing-plans/pricing-plan-form/PricingPlan.constants'
import { useI18n } from '@elo-kit/components/i18n/i18n'

const PricingPlanConsistantPayment = ({
  showTestPeriod,
  testPeriodEnabled,
  convertToPrice,
  currency,
  testPeriod,
  prefs,
  customIntervals,
  paymentsCount,
  netText,
  totalPrice,
  firstAmount,
}) => {
  const I18n = useI18n()

  const calculateConsistentPayments = () => {
    const firstRate = parseFloat(prefs[`rate1Amount`] || '0')
    let prevRate = 0
    let prevInterval = null
    let numberOfConsistentPayments = 1
    let consistentPaymentsFinished = false
    let increasingTrend = true
    let increasingTrendFinished = false
    if (customIntervals) {
      for (let i = 0; i < paymentsCount; i++) {
        const rate = parseFloat(prefs[`rate${i + 1}Amount`] || '0')
        const rateInterval = prefs[`rate${i + 1}Interval`] // only 1d, 1w, 1m, 1y intervals are supported

        if (i !== 0) {
          if (rate === prevRate && rateInterval === prevInterval && !consistentPaymentsFinished) {
            numberOfConsistentPayments++
          } else {
            consistentPaymentsFinished = true
          }

          if ((prevRate > rate && !increasingTrendFinished) || !['1d', '1w', '1m', '1y'].includes(prevInterval)) {
            increasingTrend = false
            increasingTrendFinished = true
          }
        }

        prevRate = rate
        prevInterval = rateInterval
      }
    }
    const intervalTextMap = {
      '1d': 'day',
      '1w': 'week',
      '1m': 'month',
      '1y': 'year',
    }
    const intervalText = intervalTextMap[prevInterval] || 'day'

    return {
      supportiveText: `${buildPricingPlanSupportiveText(intervalText).perKey} ${I18n.t(
        'react.shared.pricing_plan.for_the_first'
      )} ${numberOfConsistentPayments} ${buildPricingPlanSupportiveText(intervalText).forKey}`.toLowerCase(),
      firstRate: customIntervals ? convertToPrice(firstRate, currency) : convertToPrice(firstAmount, currency),
      isIncreasingTrend: increasingTrend,
      isPaymentIdentical: numberOfConsistentPayments == paymentsCount,
    }
  }

  return (
    <>
      <div className='pricing-plan-consistent-payment' translate='no'>
        {/* Free Trial Messaging */}
        {showTestPeriod && testPeriodEnabled && (
          <EloPriceDisplay
            price={convertToPrice(0, currency)}
            size='medium'
            supportiveText={`${I18n.t('react.shared.pricing_plan.for_the_first')} ${testPeriod} ${I18n.t(
              `react.shared.common.in_days`
            )}`.toLowerCase()}
          />
        )}

        {/* Pay Today Amount */}
        {!(showTestPeriod && testPeriodEnabled) && (
          <EloPriceDisplay
            price={calculateConsistentPayments().firstRate}
            netPrice={netText}
            supportiveText={
              customIntervals &&
              calculateConsistentPayments().isIncreasingTrend &&
              !calculateConsistentPayments().isPaymentIdentical
                ? calculateConsistentPayments().supportiveText
                : I18n.t('react.common.filters.daterange_filter.today')
            }
            size='small'
          />
        )}

        {/* Total Price */}
        <div className='pricing-plan-consistent-payment__total'>
          <EloPriceDisplay
            price={totalPrice}
            size='extra-small'
            supportiveText={I18n.t('react.shared.pricing_plan.over_payments', { paymentsCount })}
          />
        </div>
      </div>
    </>
  )
}

export default PricingPlanConsistantPayment
